import PropTypes from 'prop-types'
import { useCallback, useState } from "react"

import { Button } from 'twyne-new.ui';

import ConfigureComponent from '@Components/drilldown/Configure'

const propTypes = {
  onUpdate: PropTypes.func,
  options: PropTypes.array,
  selectedFields: PropTypes.array,
};

function Configure({ onUpdate, options, selectedFields }) {
  const [open, setOpen] = useState(false)

  const handleApply = useCallback(selectedFields => {
    onUpdate(selectedFields)
    setOpen(false)
  }, [])

  return <>
    {open ? <ConfigureComponent
      fields={selectedFields}
      allFields={options}
      onApply={handleApply}
      onCancel={() => setOpen(false)}
    /> : <Button variant='outline' size="lg" onClick={() => setOpen(true)}>
      Configure
    </Button>}
  </>
}

Configure.propTypes = propTypes

export default Configure
